export default __webpack_public_path__ + "static/media/dansketext-regular.c9aa6505.woff";